module.exports = __webpack_public_path__ + "img/fffBack.2e7fb7cf.svg";